import * as swcHelpers from '@swc/helpers';
import { getContactLensSpecs } from './get-contact-lens-specs.js';
import { getEyeSide } from './get-eye-side.js';
import { getAttribute } from './get-line-item-attribute.js';
import { getLineItemImageUrl } from './get-line-item-image-url.js';
import { getLocalizedAttribute } from './get-line-item-localized-attribute.js';
import { getLocalizedAttributes } from './get-line-item-localized-attributes.js';
import { getProductUrl } from './get-line-item-product-url.js';
import { getLocalizedString } from './get-localized-string.js';
import { getSharedProps } from './shared-line-item-data-mapper.js';
import { mapBundleProduct } from '../mappers/view/line-item/bundle-product.js';

const mapRegularProduct = (lineItemRaw, settings, intl)=>{
    const product = lineItemRaw.legacyProduct;
    const variant = product.masterData.current.variant;
    const shared = getSharedProps(lineItemRaw, product, intl);
    const slug = getLocalizedString(intl.locale, product.masterData.current.slug);
    const imageUrl = getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled);
    const brand = {
        name: getAttribute(variant, 'brand'),
        model: getAttribute(variant, 'brandModel'),
        modelCode: getAttribute(variant, 'brandModelCode')
    };
    const productAttributes = {
        sku: lineItemRaw.sku,
        productSlug: slug,
        productId: product.id,
        productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale),
        brand
    };
    switch(product.productType.toLowerCase()){
        case 'frames':
            return swcHelpers.objectSpread({
                type: 'frames'
            }, shared, productAttributes, {
                imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled),
                subtitle: intl.getLabel('products.frames.frameOnly.description')
            });
        case 'solutions':
            return swcHelpers.objectSpread({
                type: 'solutions'
            }, shared, productAttributes, {
                imageUrl,
                solutionType: getAttribute(variant, 'solutionType'),
                solutionVolume: getAttribute(variant, 'volume')
            });
        case 'contact-lenses':
            return swcHelpers.objectSpread({
                type: 'contact-lenses'
            }, shared, productAttributes, {
                imageUrl,
                colorLens: getAttribute(variant, 'color'),
                eyeSide: getEyeSide(lineItemRaw.typeDetails),
                lensType: getLocalizedAttribute(variant, 'lensType', intl.locale) || '',
                material: getLocalizedAttribute(variant, 'material', intl.locale) || '',
                packageQuantity: getAttribute(variant, 'packageQuantity'),
                replacementFrequency: getLocalizedAttribute(variant, 'replacementFrequency', intl.locale),
                sapArticleNumber: getAttribute(variant, 'sapArticleNumber'),
                specs: getContactLensSpecs(variant.attributes)
            });
        case 'sunglasses':
            return swcHelpers.objectSpread({
                type: 'sunglasses'
            }, shared, productAttributes, {
                imageUrl,
                imageAlt: `${brand.name} ${brand.model}`,
                subtitle: `${brand.model} ${brand.modelCode && brand.modelCode !== brand.model ? brand.modelCode : ''}`,
                frame: {
                    frameShape: getLocalizedAttribute(variant, 'frameShape', intl.locale),
                    frameMaterial: getLocalizedAttributes(variant, 'frameMaterial', intl.locale),
                    frameColor: getLocalizedAttributes(variant, 'frameColor', intl.locale)
                },
                gender: getLocalizedAttributes(variant, 'gender', intl.locale)
            });
        case 'ready-readers':
            return swcHelpers.objectSpread({
                type: 'ready-readers'
            }, shared, productAttributes, {
                gender: getLocalizedAttributes(variant, 'gender', intl.locale),
                imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled),
                power: getAttribute(variant, 'power')
            });
        case 'accessories':
            return swcHelpers.objectSpread({
                type: 'accessories'
            }, shared, productAttributes, {
                gender: getLocalizedAttributes(variant, 'gender', intl.locale),
                material: getLocalizedAttribute(variant, 'material', intl.locale) || '',
                accessoryType: getLocalizedAttribute(variant, 'accessoryType', intl.locale) || '',
                accessoryColor: getLocalizedAttributes(variant, 'accessoryColor', intl.locale),
                imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled)
            });
        default:
            console.log(`Encountered unsupported productType '${product.productType}' with sku '${variant.sku}'`);
            return null;
    }
};
// Maps the server model to client view model
const lineItemDataMapper = (lineItemsRaw, settings, intl)=>{
    const lineItems = lineItemsRaw.map((lineItemRaw)=>{
        switch(lineItemRaw.__typename){
            case 'LineItemBundle':
                return mapBundleProduct(lineItemRaw, settings, intl);
            case 'LineItemContactLenses':
            case 'LineItemRegular':
                return mapRegularProduct(lineItemRaw, settings, intl);
        }
    });
    return lineItems.filter((lineItem)=>Boolean(lineItem)
    );
};

export { lineItemDataMapper };
//# sourceMappingURL=line-item-data-mapper.js.map
